import { render, staticRenderFns } from "./people-plus.vue?vue&type=template&id=e0ee797a&scoped=true&"
import script from "./people-plus.vue?vue&type=script&lang=js&"
export * from "./people-plus.vue?vue&type=script&lang=js&"
import style0 from "./people-plus.vue?vue&type=style&index=0&id=e0ee797a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ee797a",
  null
  
)

export default component.exports